// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Interview tab — Paper Dashboard look & feel (scoped with "iv-").
   Palette: primary #51cbce, text #252422 / #66615b, muted #9a9a9a,
   borders #e3e3e3.
   ========================================================================== */

/* The tab body scrolls as a whole (steps first, description below). */
.iv-page {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 4px 6px 12px;
}

.iv-section + .iv-section {
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #eeeeee;
}

.iv-section-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 12px;
}

.iv-section-title {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 600;
    color: #252422;
}

.iv-section-sub {
    margin: 2px 0 0;
    font-size: 12.5px;
    color: #9a9a9a;
}

.iv-actions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.iv-actions .btn {
    margin: 0;
}

.iv-readonly-note {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #8a6100;
    background: #fff4d6;
    border-radius: 999px;
    padding: 3px 10px;
}

/* ---------- Steps ---------- */
.iv-steps {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.iv-step {
    background: #fff;
    border: 1px solid #e3e3e3;
    border-left: 4px solid transparent;
    border-radius: 8px;
    transition: box-shadow .15s ease, border-color .15s ease, background .15s ease;
}

.iv-step:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
}

.iv-step.is-selected {
    border-color: #51cbce;
    border-left-color: #51cbce;
    box-shadow: 0 2px 10px rgba(81, 203, 206, .15);
}

.iv-step.is-dragging {
    background: #f2fbfb;
    box-shadow: 0 6px 18px rgba(0, 0, 0, .12);
}

.iv-step-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.iv-drag {
    color: #c4c4c4;
    cursor: grab;
    font-size: 16px;
    line-height: 1;
}

.iv-drag:hover {
    color: #51cbce;
}

.iv-step-num {
    flex: 0 0 28px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    background: rgba(81, 203, 206, .15);
    color: #3aa9ac;
}

.iv-step.is-selected .iv-step-num {
    background: #51cbce;
    color: #fff;
}

.iv-step-text {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.iv-step-title {
    font-weight: 600;
    font-size: 14px;
    color: #252422;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.iv-step-desc {
    font-size: 12.5px;
    color: #9a9a9a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.iv-chevron {
    color: #9a9a9a;
    font-size: 12px;
    transition: transform .2s ease;
}

.iv-step.is-open .iv-chevron {
    transform: rotate(180deg);
    color: #51cbce;
}

.iv-step-body {
    padding: 4px 14px 14px 58px;
}

.iv-field-label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #66615b;
    margin-bottom: 6px;
}

.iv-textarea {
    resize: vertical;
    border-radius: 6px !important;
    border: 1px solid #dddddd !important;
    font-size: 14px;
    line-height: 1.5;
    max-height: none !important;
    overflow-wrap: anywhere;
}

.iv-textarea:focus {
    border-color: #51cbce !important;
    box-shadow: 0 0 0 2px rgba(81, 203, 206, .15) !important;
}

.iv-empty {
    text-align: center;
    color: #9a9a9a;
    padding: 28px 12px;
    font-size: 13px;
    border: 1px dashed #dddddd;
    border-radius: 8px;
}

.iv-empty i {
    display: block;
    font-size: 26px;
    margin-bottom: 8px;
    color: #c4c4c4;
}

@media (max-width: 576px) {
    .iv-step-body {
        padding-left: 14px;
    }
}

/* Centred section (Interview Description): narrower column in the middle */
.iv-section--center > * {
    max-width: 820px;
    margin-left: auto;
    margin-right: auto;
}

.iv-section--center .iv-section-head {
    justify-content: center;
    text-align: center;
}

/* Section headings (title, hint, buttons) centred in the middle of the tab */
.iv-section--head-center .iv-section-head {
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.iv-section--head-center .iv-actions {
    justify-content: center;
}

.iv-page {
    text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/views/industry/advertisements/Interview/interview.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E,sEAAsE;AACtE;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,8EAA8E;AAClF;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,wDAAwD;AAC5D;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA,2EAA2E;AAC3E;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA,6EAA6E;AAC7E;IACI,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["/* ==========================================================================\n   Interview tab — Paper Dashboard look & feel (scoped with \"iv-\").\n   Palette: primary #51cbce, text #252422 / #66615b, muted #9a9a9a,\n   borders #e3e3e3.\n   ========================================================================== */\n\n/* The tab body scrolls as a whole (steps first, description below). */\n.iv-page {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 4px 6px 12px;\n}\n\n.iv-section + .iv-section {\n    margin-top: 24px;\n    padding-top: 20px;\n    border-top: 1px solid #eeeeee;\n}\n\n.iv-section-head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-bottom: 12px;\n}\n\n.iv-section-title {\n    margin: 0;\n    font-size: 1.15rem;\n    font-weight: 600;\n    color: #252422;\n}\n\n.iv-section-sub {\n    margin: 2px 0 0;\n    font-size: 12.5px;\n    color: #9a9a9a;\n}\n\n.iv-actions {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.iv-actions .btn {\n    margin: 0;\n}\n\n.iv-readonly-note {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    color: #8a6100;\n    background: #fff4d6;\n    border-radius: 999px;\n    padding: 3px 10px;\n}\n\n/* ---------- Steps ---------- */\n.iv-steps {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.iv-step {\n    background: #fff;\n    border: 1px solid #e3e3e3;\n    border-left: 4px solid transparent;\n    border-radius: 8px;\n    transition: box-shadow .15s ease, border-color .15s ease, background .15s ease;\n}\n\n.iv-step:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, .06);\n}\n\n.iv-step.is-selected {\n    border-color: #51cbce;\n    border-left-color: #51cbce;\n    box-shadow: 0 2px 10px rgba(81, 203, 206, .15);\n}\n\n.iv-step.is-dragging {\n    background: #f2fbfb;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, .12);\n}\n\n.iv-step-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 14px;\n    cursor: pointer;\n    user-select: none;\n}\n\n.iv-drag {\n    color: #c4c4c4;\n    cursor: grab;\n    font-size: 16px;\n    line-height: 1;\n}\n\n.iv-drag:hover {\n    color: #51cbce;\n}\n\n.iv-step-num {\n    flex: 0 0 28px;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 700;\n    background: rgba(81, 203, 206, .15);\n    color: #3aa9ac;\n}\n\n.iv-step.is-selected .iv-step-num {\n    background: #51cbce;\n    color: #fff;\n}\n\n.iv-step-text {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.iv-step-title {\n    font-weight: 600;\n    font-size: 14px;\n    color: #252422;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.iv-step-desc {\n    font-size: 12.5px;\n    color: #9a9a9a;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.iv-chevron {\n    color: #9a9a9a;\n    font-size: 12px;\n    transition: transform .2s ease;\n}\n\n.iv-step.is-open .iv-chevron {\n    transform: rotate(180deg);\n    color: #51cbce;\n}\n\n.iv-step-body {\n    padding: 4px 14px 14px 58px;\n}\n\n.iv-field-label {\n    display: block;\n    font-size: 12px;\n    font-weight: 600;\n    color: #66615b;\n    margin-bottom: 6px;\n}\n\n.iv-textarea {\n    resize: vertical;\n    border-radius: 6px !important;\n    border: 1px solid #dddddd !important;\n    font-size: 14px;\n    line-height: 1.5;\n    max-height: none !important;\n    overflow-wrap: anywhere;\n}\n\n.iv-textarea:focus {\n    border-color: #51cbce !important;\n    box-shadow: 0 0 0 2px rgba(81, 203, 206, .15) !important;\n}\n\n.iv-empty {\n    text-align: center;\n    color: #9a9a9a;\n    padding: 28px 12px;\n    font-size: 13px;\n    border: 1px dashed #dddddd;\n    border-radius: 8px;\n}\n\n.iv-empty i {\n    display: block;\n    font-size: 26px;\n    margin-bottom: 8px;\n    color: #c4c4c4;\n}\n\n@media (max-width: 576px) {\n    .iv-step-body {\n        padding-left: 14px;\n    }\n}\n\n/* Centred section (Interview Description): narrower column in the middle */\n.iv-section--center > * {\n    max-width: 820px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.iv-section--center .iv-section-head {\n    justify-content: center;\n    text-align: center;\n}\n\n/* Section headings (title, hint, buttons) centred in the middle of the tab */\n.iv-section--head-center .iv-section-head {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n.iv-section--head-center .iv-actions {\n    justify-content: center;\n}\n\n.iv-page {\n    text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
